import {ActionReducer, ActionReducerMap, MetaReducer} from '@ngrx/store';
import {AppState} from '../models/app.state';

import * as fromProductReducer from './product.reducer';
import * as fromWindowReducer from './window.reducer';
import * as fromFilterReducer from './filter.reducer';
import * as fromLangReducer from './language.reducer';
import * as fromAdReducer from '../container/adds/store/ad.reducers';
import * as fromCategoryReducer from './category.reducer';

import {environment} from '../../environments/environment';



export const reducers: ActionReducerMap<AppState> = {  
  productsState: fromProductReducer.reducer,
  windowsState: fromWindowReducer.reducer,
  categoriesState: fromCategoryReducer.reducer,
  filters: fromFilterReducer.reducer,
  lang: fromLangReducer.reducer, 
  ads: fromAdReducer.reducer 
};


export function logger(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return function(state: AppState, action: any): AppState {
    return reducer(state, action);
  };
}


export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? [logger]
  : [];

/*
*
* MetaReducer is formed as an array of ActionReducer that we have created.
* MetaReducer forms the root meta-reducer that is configured in application module using StoreModule.
* By default @ngrx/store uses combineReducers to create root meta-reducer.
* */



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/reducers/reducer.factory.ts